"use client";

import { useCallback } from "react";
import { track } from "../../core/client";

/**
 * 리포트 좋아요 추적 훅
 */
export function useReportLike() {
    const trackLike = useCallback((reportId: number, isLike: boolean) => {
        track("report_like", {
            report_id: reportId,
            is_like: isLike,
        });
    }, []);

    return { trackLike };
}

/**
 * 리포트 공유 추적 훅
 */
export function useReportShare() {
    const trackShare = useCallback((reportId: number, channel?: string) => {
        track("report_share", {
            report_id: reportId,
        });
    }, []);

    return { trackShare };
}

